import "./NavBarButton.css";

import React from "react";

import { Link } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export const NavBarButton = ({
  color,
  buttonText,
  listContent,
  isSingleUl,
  isMultyUl,
  isNoUl,
  redirectUrl,
  handleMoveToBottom,
}) => {
  return (
    <div>
      {isSingleUl && (
        <div className="button-container">
          <Link
            style={{ color: color }}
            className="button-actual"
            to={redirectUrl}
          >
            {buttonText}
            <ArrowForwardIosIcon
              className="nav-arrow"
              sx={{ fontSize: 11, marginLeft: 0.5, transition: "all 0.4s" }}
            />
          </Link>

          <ul className="main-ul">
            {listContent.map((item) => {
              return (
                <li key={item.url} className="main-ul-li">
                  <Link className="main-ul-li-a" to={item.url}>
                    {item.text}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {isMultyUl && (
        <div className="button-container">
          <a style={{ color: color }} className="button-actual" href="#">
            {buttonText}
            <ArrowForwardIosIcon
              className="nav-arrow"
              sx={{ fontSize: 11, marginLeft: 0.5, transition: "all 0.4s" }}
            />
          </a>
          <ul className="main-ul">
            {listContent.map((item) => {
              return (
                <li key={item.firstUlLi.text} className="main-ul-li">
                  <a className="main-ul-li-a" href="#">
                    {item.firstUlLi.text}
                    <ArrowForwardIosIcon
                      className="nav-arrow-main-ul"
                      sx={{
                        fontSize: 11,
                        marginLeft: 0.5,
                      }}
                    />
                  </a>

                  <ul className="secondary-ul">
                    {item.secondUl.map((secondUlItem) => {
                      return (
                        <li key={secondUlItem.text} className="secondary-ul-li">
                          <a className="secondary-ul-li-a" href="#">
                            {secondUlItem.text}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {isNoUl && (
        <div onClick={handleMoveToBottom} className="button-container">
          <a style={{ color: color }} className="button-actual" href="#">
            {buttonText}
          </a>
        </div>
      )}
    </div>
  );
};
